module.exports = __webpack_public_path__ + "img/head.a46965bc.png";